import PropTypes from 'prop-types'

import { Container, Text } from '@redriverpress/system'
import { renderInlineMarkdown } from 'Common/utils/markdown'
import StyledHtmlContent from './StyledHtmlContent'

export default function CourseNotes({ content }) {
  return (
    <Container pb={4}>
      <StyledHtmlContent>
        <Text
          dangerouslySetInnerHTML={{
            __html: renderInlineMarkdown(content),
          }}
          width={[1, null, 9 / 12, 7 / 12]}
        />
      </StyledHtmlContent>
    </Container>
  )
}

CourseNotes.propTypes = {
  content: PropTypes.string.isRequired,
}
